import React from 'react';
export function BonusSection() {
  const scrollToOffer = () => {
    const element = document.getElementById('oferta');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section id="bonus" className="py-5 sm:py-14 bg-[#0f172a] relative" data-id="element-79">
      <div className="max-w-6xl mx-auto px-3 sm:px-6" data-id="element-80">
        <div className="text-center mb-3 sm:mb-8" data-id="element-81">
          <h2 className="text-lg sm:text-3xl md:text-4xl font-bold text-white mb-1 sm:mb-4" data-id="element-82">
            BONUS exclusivos incluidos con tu compra
          </h2>
          <p className="text-xs sm:text-base text-gray-300 max-w-2xl mx-auto mb-3 sm:mb-6" data-id="element-83">
            Para que tengas respaldo profesional, evaluaciones sólidas y
            herramientas listas para implementar, incluimos 3 bonus
            estratégicos:
          </p>

          <div className="inline-block bg-gradient-to-r from-red-600 to-red-500 text-white font-black text-[10px] sm:text-base md:text-lg px-3 sm:px-6 py-1 sm:py-2 rounded-lg shadow-lg border-2 border-white/20" data-id="element-84">
            🎁 ¡GRATIS POR EL DÍA DE HOY!
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 sm:gap-6" data-id="element-85">
          <div className="bg-[#1e293b] rounded-xl overflow-hidden border-2 border-[#fbbf24]/50 hover:border-[#fbbf24] transition-all shadow-xl flex flex-col" data-id="element-86">
            <div className="bg-[#fbbf24]/10 p-1.5 sm:p-3 text-center border-b border-[#fbbf24]/20" data-id="element-87">
              <h3 className="text-sm sm:text-lg font-bold text-[#fbbf24]" data-id="element-88">
                BONUS #1
              </h3>
            </div>
            <div className="p-2.5 sm:p-5 flex-1 flex flex-col items-center" data-id="element-89">
              <div className="w-full max-w-[200px] aspect-square mb-2 sm:mb-4 cursor-pointer hover:scale-105 transition-transform duration-300" onClick={scrollToOffer} data-id="element-90">
                <img src="https://cdn.magicpatterns.com/uploads/hkTVHaDrurU2nYGZ7pVemq/bonus_primeros_auxilios.png" alt="Bonus 1 Primeros Auxilios" className="w-full h-full object-contain drop-shadow-2xl" data-id="element-91" />
              </div>
              <h4 className="text-sm sm:text-lg font-bold text-white mb-0.5 sm:mb-2 text-center leading-tight" data-id="element-92">
                🩺 Guía Docente de Primeros Auxilios
              </h4>
              <p className="text-gray-300 text-center text-[10px] sm:text-sm" data-id="element-93">
                Explica de forma clara y práctica cómo actuar ante emergencias
                escolares: desmayos, golpes, cortes o crisis nerviosas.
              </p>
            </div>
          </div>

          <div className="bg-[#1e293b] rounded-xl overflow-hidden border-2 border-[#fbbf24]/50 hover:border-[#fbbf24] transition-all shadow-xl flex flex-col" data-id="element-94">
            <div className="bg-[#fbbf24]/10 p-1.5 sm:p-3 text-center border-b border-[#fbbf24]/20" data-id="element-95">
              <h3 className="text-sm sm:text-lg font-bold text-[#fbbf24]" data-id="element-96">
                BONUS #2
              </h3>
            </div>
            <div className="p-2.5 sm:p-5 flex-1 flex flex-col items-center" data-id="element-97">
              <div className="w-full max-w-[200px] aspect-square mb-2 sm:mb-4 cursor-pointer hover:scale-105 transition-transform duration-300" onClick={scrollToOffer} data-id="element-98">
                <img src="https://cdn.magicpatterns.com/uploads/kYxsB2FMHUja4SXGNb8YHB/bonus_planificacion_anual.png" alt="Bonus 2 Planificación Anual" className="w-full h-full object-contain drop-shadow-2xl" data-id="element-99" />
              </div>
              <h4 className="text-sm sm:text-lg font-bold text-white mb-0.5 sm:mb-2 text-center leading-tight" data-id="element-100">
                📘 Guía Maestra de Planificación Anual
              </h4>
              <p className="text-gray-300 text-center text-[10px] sm:text-sm" data-id="element-101">
                Incluye planificaciones listas, organizadas por temas y niveles.
              </p>
            </div>
          </div>

          <div className="bg-[#1e293b] rounded-xl overflow-hidden border-2 border-[#fbbf24]/50 hover:border-[#fbbf24] transition-all shadow-xl flex flex-col" data-id="element-102">
            <div className="bg-[#fbbf24]/10 p-1.5 sm:p-3 text-center border-b border-[#fbbf24]/20" data-id="element-103">
              <h3 className="text-sm sm:text-lg font-bold text-[#fbbf24]" data-id="element-104">
                BONUS #3
              </h3>
            </div>
            <div className="p-2.5 sm:p-5 flex-1 flex flex-col items-center" data-id="element-105">
              <div className="w-full max-w-[200px] aspect-square mb-2 sm:mb-4 cursor-pointer hover:scale-105 transition-transform duration-300" onClick={scrollToOffer} data-id="element-106">
                <img src="https://cdn.magicpatterns.com/uploads/mpmmWxaMC7pgbH6xYMvNYC/CLASES_QUE_SE_PREPARAN_SOLAS_.png" alt="Bonus 3 Actividades" className="w-full h-full object-contain drop-shadow-2xl" data-id="element-107" />
              </div>
              <h4 className="text-sm sm:text-lg font-bold text-white mb-0.5 sm:mb-2 text-center leading-tight" data-id="element-108">
                ✨ Actividades para tus clases listas
              </h4>
              <p className="text-gray-300 text-center text-[10px] sm:text-sm" data-id="element-109">
                Clases listas, 50 actividades listas para que pongas en práctica
                en el aula.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}